import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./WhyBBtravel.css";

const WhyBBtravel = () => {
  return (
    <>
      <div className="container why-bbt mt-md-5 pt-md-5">
        <div className="row">
          <div className="col-md-12 mt-md-5">
            <h1 className="headings text-center fs8">
              <span>Why Choose </span>Blueberry Travels for Your Work Trip
              <b>?</b>
            </h1>
          </div>
        </div>
      </div>
      <div className="why-bbt-img details-section">
        <div className="container mt-2">
          <div className="row">
            <div className="col-md-6 col-lg-3 col-6 mt-md-5 mb-lg-5 d-flex justify-content-center padding">
              <div className="box1 office">
                <div className="d-flex flex-column pb-4 mt-xxl-5 mt-md-4 pt-5">
                  <h4 className="headings text-center first-why-section position-relative zindex mt-3 pt-2  mt-md-3 mt-xxl-4">
                    Personalized Travel
                  </h4>
                  <p className="text-center mt-2">
                    We upgrade your travel program for maximum efficiency.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-6 mt-md-5 mb-lg-5 d-flex justify-content-center padding">
              <div className="box1 phone">
                <div className="d-flex flex-column pb-4  mt-xxl-5 mt-md-4 pt-5">
                  <h4 className="headings text-center second-why-section position-relative zindex mt-3 pt-2  mt-md-3 mt-xxl-4">
                    Cost Efficiency
                  </h4>
                  <p className="text-center mt-2">
                    Enjoy premium experiences at budget-friendly prices.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-6 mt-md-5 mb-lg-5 d-flex justify-content-center mt-md-4  padding">
              <div className="box1 email">
                <div className="d-flex flex-column mt-xxl-5 mt-md-4 pt-5 pb-4">
                  <h4 className="headings text-center third-why-section position-relative zindex mt-3 pt-2  mt-md-3 mt-xxl-4">
                    Global Reach
                  </h4>
                  <p className="text-center mt-1">
                    We connect the world to simplify your travel.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-6 mt-md-5 mb-lg-5 d-flex justify-content-center mt-md-4 padding">
              <div className="box1 website">
                <div className="d-flex flex-column mt-xxl-5 mt-md-4 pt-5 pb-4">
                  <h4 className="headings text-center fourth-why-section position-relative zindex mt-3 pt-2  mt-md-3 mt-xxl-4">
                    Seamless Support
                  </h4>
                  <p className="text-center mt-1">
                    Our dedicated travel team is always available 24/7.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyBBtravel;
